import { Component, Input, OnChanges } from '@angular/core';
import {
  evaluatePasswordRules,
  PasswordRuleState,
} from '../../../utils/password-rules';

/**
 * Muestra los requisitos de la contraseña y los marca en verde a medida que se
 * cumplen, para que el usuario no la cree a ciegas.
 * Las reglas salen de PASSWORD_RULES, las mismas que valida el formulario.
 */
@Component({
  selector: 'app-password-rules-checklist',
  templateUrl: './password-rules-checklist.component.html',
  styleUrls: ['./password-rules-checklist.component.sass'],
})
export class PasswordRulesChecklistComponent implements OnChanges {
  /** Valor actual del campo de contraseña */
  @Input() value: string = '';

  /** Al cumplirse todas, colapsa a una sola linea para no empujar el formulario */
  @Input() collapseWhenComplete: boolean = true;

  rules: PasswordRuleState[] = evaluatePasswordRules('');

  ngOnChanges(): void {
    this.rules = evaluatePasswordRules(this.value);
  }

  get allMet(): boolean {
    return this.rules.every((rule) => rule.met);
  }

  get showSummary(): boolean {
    return this.collapseWhenComplete && this.allMet;
  }

  trackById(index: number, rule: PasswordRuleState): string {
    return rule.id;
  }
}
